/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import { CookieSetting } from "cookiesetting-component";
import axios from "axios";
import Header from "./components/Header";
import Banner from "./components/Banner/Banner";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import content from './components/content.json';
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import RecaptureMoments from "./components/RecaptureTheMoments/RecaptureTheMoments";
const Footer = lazy(() => import("./components/FooterNew/index.js"));
const Logo = lazy(() => import("./components/Logo Section/NewLogoSection"));
const ThankYou = lazy(() =>
  import("./components/ThankYou/Thankyou.js")
);
const PostEventMemories = lazy(() =>
  import("./components/PostEventMemories/PostEventMemories.js")
);
// const SocialMedia = lazy(() =>
//   import("./components/PostSocial/PostSocial.js")
// );
const Interior = lazy(() => import("./components/Interior/Interior.js"));

const SubscribeNotification = lazy(() => import("./components/SubscribeNotification/SubscribeForEventNotifications.js"));
const Combinedcarousel = lazy(() =>
  import("./components/CombinedCarousel/Combined.js")
);

function App() {

  const [dataJson, setDataJson] = useState(null); // Set initial state as null
  const isProduction = process.env.NODE_ENV === "production";
  const appVersion = appversion.version;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const response = await fetch(`${process.env.REACT_APP_POSTEVENT_NAMB_JSON_CDN_URL}?timestamp=${timestamp}`);
        const jsonData = await response.json();
        setDataJson(jsonData);
      } catch (error) {
        console.error('Error fetching links:', error);
        setDataJson(content); // Use local JSON data if fetching fails
      }
    };

    if (!dataJson) {
      fetchData(); // Fetch JSON only if the links data is not available
    }
  }, [dataJson]);

  useEffect(() => {
    if (!dataJson) {
      setDataJson(content); // Set local JSON data as fallback initially
    }
  }, []);

  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={process.env.PUBLIC_URL} //If public assets are hosted somewhere other than root on your server.
    >
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
      {links && dataJson ? (
        <>
          <div className="bodyContainer">
            <Header fetchpriority="high" />
            {links ? (
              <>
                <Banner fetchpriority="high" links={links} dataJson={dataJson.banner} />
                <Suspense fallback={<div />}>
                  <PostEventMemories links={links} />
                </Suspense>
                <Suspense fallback={<div />}>
                  <Interior links={links} dataJson={dataJson.interior} />
                </Suspense>

                <Suspense fallback={<div />}>
                  <RecaptureMoments />
                </Suspense>

                <Suspense fallback={<div />}>
                  <Logo />
                </Suspense>
                {/* <Suspense fallback={<div />}>
                  <SocialMedia links={links} />
                </Suspense> */}
                <Suspense fallback={<div />}>
                  <ThankYou links={links} dataJson={dataJson.Thanksbox} />
                </Suspense>
                <Suspense fallback={<div />}>
                  <SubscribeNotification />
                </Suspense>

                <Suspense fallback={<div />}>
                  <Combinedcarousel links={links} />
                </Suspense>
                <Suspense fallback={<div />}>
                  <Footer />
                </Suspense>
              </>
            ) : (
              <div>Loading...</div>
            )}
          </div>
        </>
      ) : (
        <div>Loading...</div>
      )}
    </CacheBuster>
  );
}

export default App;

